// Used to determine the maximum number of queries that can be in a layout row
// Keep in sync with back-end MAXIMUM_ROW_LENGTH
// TODO(DnDM2.3) Change the maximum columns per row to 5
export const MAXIMUM_ROW_LENGTH = 2;
